<div class="container">
  <div data-size="A4">
    <div class="float-right po-header-controls d-print-none" *ngIf="currentUserCanEdit">
      <button
        (click)="openUploadAttachmentDialog.next(purchaseOrder)"
        type="button"
        class="btn btn-outline-primary btn-sm"
      >
        <i class="far fa-paperclip"></i> Add Attachments
      </button>
      <button
        (click)="openPurchaseOrderEditDialog.next(purchaseOrder)"
        type="button"
        class="btn btn-outline-primary btn-sm"
      >
        <i class="far fa-edit"></i> Edit Receiving Document
      </button>
      <button (click)="openItemNewDialog.next()" type="button" class="btn btn-outline-primary btn-sm">
        <i class="far fa-plus"></i> Add New Item
      </button>
    </div>
    <h3>Receiving Document #{{ purchaseOrder.number }}</h3>
    <div class="row po-header-row">
      <div class="col-sm-3 po-details">
        <span class="label">Vendor</span>
        {{ purchaseOrder.vendorName }}
      </div>
      <div class="col-sm-3 po-details">
        <span class="label">Vendor Order #</span>
        {{ purchaseOrder.vendorOrderNumber }}
      </div>
      <div class="col-sm-3 po-details">
        <span class="label">Item Count</span>
        {{ (items$ | async)?.length }}
      </div>
      <div class="col-sm-3 po-details">
        <span class="label">Delivery Date</span>
        {{ (purchaseOrder.deliveryDate | date) || 'N/A' }}
      </div>
    </div>
    <div class="row po-header-row">
      <div class="col-sm-3 po-details">
        <span class="label">Order Total</span>
        {{ purchaseOrderTotal | currency }}
      </div>
      <div class="col-sm-3 po-details">
        <span class="label">Project</span>
        {{ purchaseOrder.projectCode }}
      </div>
      <div class="col-sm-3 po-details">
        <span class="label">RIP</span>
        {{ purchaseOrder.ripNumber }}
      </div>
      <div class="col-sm-3 po-details">
        <span class="label">Classification</span>
        {{ purchaseOrder.classification }}
      </div>
    </div>
    <div class="po-header-row">
      <div class="po-details">
        <span class="label">Notes</span>
        {{ purchaseOrder.notes }}
      </div>
    </div>
    <div class="po-header-row" *ngIf="attachments.length > 0">
      <div class="po-details">
        <span class="label">Attachments</span>
        <div class="row">
          <div *ngFor="let attachment of attachments" class="col-sm-6 attachments">
            <a download href="/api/PurchaseOrderAttachments/{{ attachment.id }}" class="attachment">
              <i class="far fa-paperclip"></i> {{ attachment.fileName }}</a
            >
            <button
              *ngIf="currentUserCanEdit"
              title="Delete Attachment"
              (click)="deleteAttachment.next(attachment.id)"
              class="btn btn-outline-danger btn-sm"
            >
              <i class="far fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <kendo-grid
      [data]="gridData$ | async"
      [rowHeight]="rowHeight"
      style="height: calc(100vh - 180px);"
      [resizable]="true"
      [sortable]="{
        allowUnsort: true,
        mode: 'single'
      }"
      [sort]="sort$ | async"
      [scrollable]="'virtual'"
      [pageable]="true"
      [pageSize]="pageSize"
      [skip]="skip$ | async"
      (sortChange)="sortChange($event)"
      (pageChange)="pageChange($event)"
    >
      <kendo-grid-column field="partNumber" title="Part Number"></kendo-grid-column>
      <kendo-grid-column field="manufacturerName" title="Manufacturer"></kendo-grid-column>
      <kendo-grid-column field="partDescription" title="Description"></kendo-grid-column>
      <kendo-grid-column field="serialNumber" title="Serial Number"></kendo-grid-column>
      <kendo-grid-column field="orderQuantity" title="Quantity"></kendo-grid-column>
      <kendo-grid-column field="partUnitOfIssue" title="U/I"></kendo-grid-column>
      <kendo-grid-column field="unitPrice" title="Unit Price">
        <ng-template kendoGridCellTemplate let-item>{{ item.unitPrice | currency }}</ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="totalCost" title="Total Cost">
        <ng-template kendoGridCellTemplate let-item>{{ item.totalCost | currency }}</ng-template>
      </kendo-grid-column>
      <kendo-grid-column [width]="130" field="createdTime" title="Created">
        <ng-template kendoGridCellTemplate let-item>
          {{ item.createdTime | date }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column [width]="140" title="Actions">
        <ng-template kendoGridCellTemplate let-item>
          <div class="no-wrap">
            <button
              (click)="openItemEditDialog.next(item)"
              title="Edit"
              type="button"
              class="btn btn-outline-primary btn-sm no-wrap"
            >
              <i class="far fa-edit"></i>
            </button>
            <ng-container *ngIf="currentUserCanEdit">
              &nbsp;
              <button
                (click)="openCloneItemDialog.next(item)"
                title="Clone this item"
                type="button"
                class="btn btn-outline-info btn-sm no-wrap"
              >
                <i class="far fa-copy"></i>
              </button>
              &nbsp;
              <button
                (click)="deleteItem.next(item)"
                title="Delete item from system"
                type="button"
                class="btn btn-outline-danger btn-sm no-wrap"
              >
                <i class="far fa-trash-alt"></i>
              </button>
            </ng-container>
          </div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>
